export default "__VITE_ASSET__7110cbae__"